import breakpoints from "../breakpoints";

export default function addInfoToggles(calculatorElement) {
    let ticketInfoToggleBtns = calculatorElement.querySelectorAll('.btn-toggle-ticket-info');
    let presaleInfoToggleBtns = calculatorElement.querySelectorAll('.btn-toggle-presale-info');

    //add event listeners for info toggle buttons depending on mobile desktop
    if (window.innerWidth < breakpoints('lg')) {
        for (const btn of ticketInfoToggleBtns) {
            btn.addEventListener('click', () => toggleInfoBox(btn, 'ticket', btn.dataset.infotoggle));
        }
        for (const btn of presaleInfoToggleBtns) {
            btn.addEventListener('click', () => toggleInfoBox(btn, 'presale', btn.dataset.infotoggle));
        }
    } else {
        for (const btn of ticketInfoToggleBtns) {
            if (btn.dataset.infotoggle === 'open') {
                btn.addEventListener('mouseover', () => toggleInfoBox(btn, 'ticket', btn.dataset.infotoggle));
            }
        }
        for (const btn of presaleInfoToggleBtns) {
            if (btn.dataset.infotoggle === 'open') {
                btn.addEventListener('mouseover', () => toggleInfoBox(btn, 'presale', btn.dataset.infotoggle));
            }
        }
    }
}

function toggleInfoBox(trigger, type, show) {
    switch (type) {
        case 'ticket':
            let tInfoEl = trigger.parentNode.querySelector('.ticket-info-container');
            if (!tInfoEl) {
                tInfoEl = trigger.closest('.ticket-info-container');
            }
            if (show === 'open') {
                tInfoEl.classList.remove('hidden');
                if (window.innerWidth >= breakpoints('lg')) {
                    tInfoEl.addEventListener('mouseleave', () => toggleInfoBox(trigger, 'ticket', 'hide'));
                }
            } else {
                tInfoEl.classList.add('hidden');
            }
            break;
        case 'presale':
            let pInfoEl = trigger.parentNode.querySelector('.presale-info-container');
            if (!pInfoEl) {
                pInfoEl = trigger.closest('.presale-info-container');
            }
            if (show === 'open') {
                pInfoEl.classList.remove('hidden');
                if (window.innerWidth >= breakpoints('lg')) {
                    pInfoEl.addEventListener('mouseleave', () => toggleInfoBox(trigger, 'presale', 'hide'));
                }
            } else {
                pInfoEl.classList.add('hidden');
            }
            break;
    }
}
